import React, { PureComponent } from 'react'
import axios from 'axios'
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  FormGroup,
  Label,
  Input,
} from 'reactstrap'
import AddressInput from '../Components/AddressInput/AddressInput'
import HoursInput from '../Components/HoursInput/HoursInput'
import Alert from '../Widgets/Alert'
import ImageUpload from '../../components/ImageUpload'
import withAlertTimeout from '../../HOCs/withAlertTimeout'
import authProtection from '../../HOCs/authProtection'
import {
  uploadToCloudinary,
  createImageObj,
} from '../../helpers/cloudinaryUpload'

const EMPTY_BUSINESS = {
  name: '',
  description: '',
  contact: {},
  location: {},
  categories: [],
  avatar: null,
  cover: null,
}


class AddBusiness extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      categoriesOpen: false,
      business: EMPTY_BUSINESS,
      avatarPreview: null,
      coverPreview: null,
      isSubmitting: false,
      errors: {
        name: false,
        location: false,
        phone: false
      },
      businessCategories: [],
      success: false,
      failure: false,
      daysTimeBlocks: null,
      displayData: [],
      linkKeyValuePairs: [],
      arrayLength: 0,
      previousContacts: []
    }

    this.onLocationUpdate = this.onLocationUpdate.bind(this)
    this.onFieldChange = this.onFieldChange.bind(this)
    this.onContactChange = this.onContactChange.bind(this)
    this.onAvatarChange = this.onAvatarChange.bind(this)
    this.onAvatarPreview = this.onAvatarPreview.bind(this)
    this.onAvatarRemove = this.onAvatarRemove.bind(this)
    this.onCoverChange = this.onCoverChange.bind(this)
    this.onCoverPreview = this.onCoverPreview.bind(this)
    this.onCoverRemove = this.onCoverRemove.bind(this)
    this.onSubmitClick = this.onSubmitClick.bind(this)
    this.onCategorySelect = this.onCategorySelect.bind(this)
    this.showLoginModal = this.showLoginModal.bind(this)
    this.uploadImages = this.uploadImages.bind(this)
    this.updateHours = this.updateHours.bind(this)
    this.addField = this.addField.bind(this)
    this.updateFieldsState = this.updateFieldsState.bind(this)
  }

  componentDidMount() {
    document.querySelector('#company').focus()
    this.fetchCategories()
  }

  async uploadImages() {
    const avatarUpload = this.state.business.avatar
      ? uploadToCloudinary(this.state.business.avatar)
      : null
    const coverUpload = this.state.business.cover
      ? uploadToCloudinary(this.state.business.cover)
      : null
    try {
      const [avatar, cover] = await Promise.all([avatarUpload, coverUpload])
      return {
        avatar: createImageObj(avatar),
        cover: createImageObj(cover),
      }
    } catch (e) {
      console.log(e)
      window.scrollTo(0, 0)
      this.props.showFailure()
    }
  }

  onLocationUpdate(newLocation) {
    this.setState({
      business: {
        ...this.state.business,
        location: newLocation,
      },
    })
  }

  onFieldChange(e) {
    this.setState({
      business: { ...this.state.business, [e.target.name]: e.target.value },
    })
  }

  updateFieldsState(e) {
    console.log(e.target.name)
    this.setState({
      linkKeyValuePairs : {
        ...this.state.linkKeyValuePairs,
        [e.target.name] : e.target.value
      }
    })
  }

  onContactChange(e) {
    this.setState({
      business: {
        ...this.state.business,
        contact: {
          ...this.state.business.contact,
          [e.target.name]: e.target.value,
        },
      },
    })
  }

  onAvatarChange(rawImage) {
    this.setState({
      business: {
        ...this.state.business,
        avatar: rawImage,
      },
    })
  }

  onAvatarPreview(avatarPreview) {
    this.setState({ avatarPreview })
  }

  onAvatarRemove(e) {
    e.stopPropagation()
    this.setState({
      avatarPreview: null,
      business: { ...this.state.business, avatar: null },
    })
  }

  onCoverChange(rawImage) {
    this.setState({
      business: {
        ...this.state.business,
        cover: rawImage,
      },
    })
  }

  onCoverPreview(coverPreview) {
    this.setState({ coverPreview })
  }

  onCoverRemove(e) {
    e.stopPropagation()
    this.setState({
      coverPreview: null,
      business: { ...this.state.business, cover: null },
    })
  }

  onCategorySelect(e) {
    const selectedIDs = Array.from(e.target.selectedOptions).map(
      option => option.value
    )
    this.setState({
      business: {
        ...this.state.business,
        categories: selectedIDs,
      },
    })
  }

  onSubmitClick() {
    console.log(this.state.business.contact)
    const hasNoName = !this.state.business.name.length
    const hasNoLocation = !this.state.business.location.coordinates
    const hasNoPhone = !this.state.business.contact.phone
    if (hasNoName || hasNoLocation || hasNoPhone) {
      this.setState({
        errors: { name: hasNoName || false, location: hasNoLocation || false,  phone: hasNoPhone || false},
      })
    } else {
      this.createBusiness()
    }
  }

  async createBusiness() {
    this.setState({ isSubmitting: true })
    const token = sessionStorage.getItem('token')

    const headers = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : null
      
      let newFields = {}
      for (let index = 0; index < this.state.arrayLength; index++) {
        newFields[this.state.linkKeyValuePairs['linkKey' + index]]= this.state.linkKeyValuePairs['linkValue' + index]
      }
      const contacts = this.state.business.contact !== null ? this.state.business.contact : this.state.previousContacts
      if(this.state.business.contact !== null) this.setState({ previousContacts: this.state.business.contact})
      this.setState({
        business: {
          ...this.state.business,
          contact: {
            ...contacts,
            ...newFields
          },
        },
      })
      
    try {
      const { avatar, cover } = await this.uploadImages()
      const payload = {
        ...this.state.business,
        avatar,
        cover,
        daysTimeBlocks: this.state.daysTimeBlocks,
      }

      axios
        .post(`/api/proxy/v2/businesses`, payload, headers)
        .then(({ data }) => {
          this.setState({
            isSubmitting: false,
            business: EMPTY_BUSINESS,
            errors: { name: false, location: false },
            coverPreview: null,
            avatarPreview: null,
          })
          window.scrollTo(0, 0)
          this.props.showSuccess()
        })
        .catch(errors => {
          console.log("errorssss", errors)
          this.setState({
            business: {
              ...this.state.business,
              contact: null
            },
          })
        })
    } catch (e) {
      this.setState({ isSubmitting: false })
      this.setState({
        business: null
      })
      window.scrollTo(0, 0)
      this.props.showFailure()
    }
  }

  clearErrors() {
    this.setState({ errors: { name: false, location: false } })
  }

  fetchCategories() {
    axios
      .get(`/api/proxy/v2/categories`)
      .then(({ data }) => {
        const sorted = data.sort((a, b) => {
          if (a.categoryName < b.categoryName) {
            return -1
          }
          if (a.categoryName > b.categoryName) {
            return 1
          }
          return 0
        })

        this.setState({ businessCategories: sorted })
      })
      .catch(err => {
        console.log(err)
      })
  }

  showLoginModal() {
    this.props.showModal(<LoginModal redirect='/business/create' />)
  }

  renderCategories() {
    return this.state.businessCategories.map(cat => (
      <option key={cat.id} value={cat.id} onChange={this.onCategorySelect}>
        {cat.categoryName}
      </option>
    ))
  }

  updateHours(hours) {
    this.setState({
      daysTimeBlocks: hours,
    })
  }

  addField() {
    let array = this.state.displayData;
    array.push(
      <FormGroup row>
        <Col xs='6'>
          <FormGroup>
            <Input
              onChange={
                this.updateFieldsState
              }
              name={'linkKey' + array.length}
              type='text'
              id={'linkKey' + array.length}
              placeholder="Link Name"
              style={{width: '50%', marginBottom: '10px'}}
            />
            <Input
              onChange={
                this.updateFieldsState
              }
              name={'linkValue' + array.length}
              type='text'
              id={'linkValue' + array.length}
              placeholder="Link Value"
            />
          </FormGroup>
        </Col>
      </FormGroup>
    )
    this.setState({displayData: array, arrayLength: array.length})
    this.forceUpdate()
  }

  render() {
    console.log("rendered")
    const { business } = this.state
    return (
      <div className='animated fadeIn'>
        {<Alert active={this.props.success} message='Business Created' />}
        {
          <Alert
            type='danger'
            active={this.props.failure}
            message='Something went wrong, please try again'
          />
        }
        <Row>
          <Col xs='12'>
            <Card>
              <CardHeader>
                <strong>Business Info</strong>
              </CardHeader>
              <CardBody>
                <FormGroup>
                  {this.state.errors.name && (
                    <p style={{ color: 'red', marginBottom: 0 }}>
                      This field is required
                    </p>
                  )}

                  <Label htmlFor='company'>Name (required)</Label>
                  <Input
                    type='text'
                    id='company'
                    placeholder='Enter your company name'
                    name='name'
                    value={this.state.business.name}
                    onChange={this.onFieldChange}
                  />
                </FormGroup>
                <FormGroup row>
                  <Col xs='6'>
                    <Label htmlFor='catgories'>
                      Categories{' '}
                      <small>
                        (hold "cmd" or "ctrl" key while clicking to select
                        multiple)
                      </small>
                    </Label>
                    <Input
                      type='select'
                      name='multiple-select'
                      id='multiple-select'
                      style={{ height: 200 }}
                      multiple
                      onChange={this.onCategorySelect}>
                      {this.renderCategories()}
                    </Input>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Label htmlFor='avatar'>Avatar Photo</Label>
                  <ImageUpload noCompression onUpload={this.onAvatarChange} />
                </FormGroup>
                <FormGroup>
                  <Label htmlFor='avatar'>Cover Photo</Label>
                  <ImageUpload noCompression onUpload={this.onCoverChange} />
                </FormGroup>
                <FormGroup>
                  <Label htmlFor='description'>Description</Label>
                  <Input
                    type='textarea'
                    name='textarea-input'
                    id='textarea-input'
                    rows='9'
                    name='description'
                    value={this.state.business.description}
                    onChange={this.onFieldChange}
                  />
                </FormGroup>

                <FormGroup row>
                  <Col xs='6'>
                    <FormGroup>
                      {this.state.errors.phone && (
                        <p style={{ color: 'red', marginBottom: 0 }}>
                          This field is required
                        </p>
                      )}
                      <Label htmlFor='phone'>Phone (required)</Label>
                      <Input
                        onChange={this.onContactChange}
                        name='phone'
                        type='text'
                        id='phone'
                      />
                    </FormGroup>
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Col xs='6'>
                    <FormGroup>
                      <Label htmlFor='website'>Website</Label>
                      <Input
                        onChange={this.onContactChange}
                        name='url'
                        type='text'
                      />
                    </FormGroup>
                  </Col>
                </FormGroup>

                <FormGroup row>
                  <Col xs='6'>
                    <FormGroup>
                      <Label htmlFor='Twitter'>Twitter</Label>
                      <Input
                        onChange={this.onContactChange}
                        name='twitter'
                        type='text'
                        id='twitter'
                      />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col xs='6'>
                    <FormGroup>
                      <Label htmlFor='Facebook'>Facebook</Label>
                      <Input
                        onChange={this.onContactChange}
                        name='facebook'
                        type='text'
                        id='facebook'
                      />
                    </FormGroup>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col xs='6'>
                    <FormGroup>
                      <Label htmlFor='Instagram'>Instagram</Label>
                      <Input
                        onChange={this.onContactChange}
                        name='instagram'
                        type='text'
                        id='instagram'
                      />
                    </FormGroup>
                  </Col>
                </FormGroup>

                {this.state.displayData.map((component, index) => <div key={index}>{component}</div>)}

                <div className="form-actions" style={{width: 'min-width', 
                      paddingBottom: '10px'}}>
                  <Button
                    onClick={this.addField}
                    type="submit"
                    color="primary"
                    disabled={false}
                  >
                    Add Field
                  </Button>
                </div>
                
                {this.state.errors.location && (
                  <p style={{ color: 'red', marginBottom: 0 }}>
                    This field is required
                  </p>
                )}
                <AddressInput
                  onUpdateLocation={this.onLocationUpdate}
                  selectedLocation={business.location}
                  clearValue={this.state.success || this.state.failure}
                />
                <br />
                <Label>Hours</Label>
                <HoursInput updateHours={this.updateHours} />
                <br />
                <div className='form-actions'>
                  <Button
                    onClick={this.onSubmitClick}
                    type='submit'
                    color='primary'>
                    {this.state.isSubmitting && (
                      <i
                        className='fa fa-circle-o-notch fa-spin'
                        style={{ marginRight: 5 }}
                      />
                    )}
                    Submit
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default authProtection(withAlertTimeout(AddBusiness))



// WEBPACK FOOTER //
// ./src/views/Pages/AddBusiness.js